export default "/images/60cebcee3187e3be7da8bd42b423daf5.png";